import { render, staticRenderFns } from "./emoji_reactions.vue?vue&type=template&id=65d5acdf&scoped=true&"
import script from "./emoji_reactions.vue?vue&type=script&lang=js&"
export * from "./emoji_reactions.vue?vue&type=script&lang=js&"
import style0 from "./emoji_reactions.vue?vue&type=style&index=0&id=65d5acdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d5acdf",
  null
  
)

export default component.exports